/*
 * Русский перевод поиска (страница и модальное окно) и его React-части.
 */
import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { searchTranslationRef } from '@backstage/plugin-search';
import { searchReactTranslationRef } from '@backstage/plugin-search-react';

const searchRu = createTranslationMessages({
  ref: searchTranslationRef,
  full: false,
  messages: {
    'searchModal.viewFullResults': 'Все результаты',
    'searchType.allResults': 'Все результаты',
    'searchType.tabs.allTitle': 'Все',
    'searchType.accordion.allTitle': 'Все',
    'searchType.accordion.collapse': 'Свернуть',
    'searchType.accordion.numberOfResults': 'результатов: {{number}}',
    'sidebarSearchModal.title': 'Поиск',
  },
});

const searchReactRu = createTranslationMessages({
  ref: searchReactTranslationRef,
  full: false,
  messages: {
    'searchBar.title': 'Поиск',
    'searchBar.placeholder': 'Поиск в {{org}}',
    'searchBar.clearButtonTitle': 'Очистить',
    'searchFilter.allOptionTitle': 'Все',
    'searchPagination.limitLabel': 'На странице:',
    'searchPagination.limitText': 'из {{num}}',
    noResultsDescription: 'Ничего не найдено',
    'searchResultGroup.linkTitle': 'Показать все',
    'searchResultGroup.addFilterButtonTitle': 'Добавить фильтр',
    'searchResultPager.previous': 'Назад',
    'searchResultPager.next': 'Далее',
  },
});

export const searchTranslations = [
  createTranslationResource({
    ref: searchTranslationRef,
    translations: { ru: () => Promise.resolve({ default: searchRu }) },
  }),
  createTranslationResource({
    ref: searchReactTranslationRef,
    translations: { ru: () => Promise.resolve({ default: searchReactRu }) },
  }),
];
